import Glide from '@glidejs/glide';


export const partnersGlider = new Glide('#partnersGlide', {
    type: 'slider',
    startAt: 0,
    gap: 8,
    perView: 1,
    perSwipe: '|',
});
